import { Container, LeftArrow } from './style';

export default function CustomLeftArrow({ onClick }) {
  return (
    <Container onClick={() => onClick()}>
      <LeftArrow size={30} />
    </Container>
  );
}
